import { Button, MagellanPopup } from 'components/atoms';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiTrash, PiWarning } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IPopupDeleteWarningProps {
  trigger?: JSX.Element;
  disabledTrigger?: boolean;
  name?: string;
  onRemove?: (actions: PopupActions) => void;
  removeLoading?: boolean;
  transI18nKey?: string;
  isClear?: boolean;
}

const PopupDeleteWarning = ({
  trigger,
  disabledTrigger,
  name = '',
  onRemove,
  removeLoading,
  transI18nKey,
  isClear = true,
}: IPopupDeleteWarningProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);
  return (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={
        trigger ?? (
          <Button
            isClear={isClear}
            onlyIcon
            variant={BUTTON_VARIANT.remove}
            disabled={disabledTrigger}>
            <Button.Description description={t('button.remove')} />
            <Button.Icon icon={<PiTrash />} />
          </Button>
        )
      }>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4'>
          <p>
            <Trans
              i18nKey={transI18nKey ?? 'popup.delete-popup'}
              values={{ name: name }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t(`popup.question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.cancel`)} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.remove}
            onClick={() =>
              onRemove && popupRef.current && onRemove(popupRef.current)
            }
            isLoading={removeLoading}>
            <Button.Text text={t(`popup.approve`)} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default PopupDeleteWarning;
